import React from 'react';
import { Container } from '../components/ui/Container';
import { PricingCard } from '../components/PricingCard';
import { FAQSection } from '../components/FAQSection';
import { Button } from '../components/ui/Button';
export function PricingPage() {
  return <div className="bg-white" data-id="element-428">
      {/* Hero */}
      <div className="bg-gray-900 py-20 lg:py-32 text-center text-white" data-id="element-429">
        <Container data-id="element-430">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6" data-id="element-431">
            Simple, Transparent Pricing
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-10" data-id="element-432">
            Choose the plan that fits your needs. All plans billed annually.
          </p>
        </Container>
      </div>

      {/* Pricing Cards */}
      <div className="-mt-20 pb-24" data-id="element-433">
        <Container data-id="element-434">
          <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-435">
            <PricingCard name="Free Tier" price="$0" period="/year" description="Perfect for testing with one flow" cta="Try for Free" ctaLink="https://app.useflowsense.com/auth/signup" features={['1 flow analysis', 'Basic recommendations', '7-day performance tracking', 'Email support']} data-id="element-436" />
            <PricingCard name="Pro Tier" price="$500" period="/year" description="Everything you need to optimize all flows" cta="Sign Up" ctaLink="https://app.useflowsense.com/auth/signup" highlighted={true} features={['Unlimited flow analysis', 'Advanced AI recommendations', 'Full ROI tracking', 'Brand voice analysis', 'Priority support', 'Export reports']} data-id="element-437" />
            <PricingCard name="Agency" price="$500" period="/year" description="For the first client, then $300/year per additional client" cta="Contact Sales" ctaLink="https://app.useflowsense.com/auth/signup" features={['Everything in Pro', 'Unlimited client accounts', 'White-label reports', 'Custom domain', 'Team collaboration', 'Dedicated support']} data-id="element-438" />
          </div>
        </Container>
      </div>

      {/* FAQ */}
      <section className="py-24 bg-gray-50" data-id="element-439">
        <Container data-id="element-440">
          <div className="text-center mb-16" data-id="element-441">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900" data-id="element-442">
              Frequently Asked Questions
            </h2>
          </div>
          <FAQSection items={[{
          question: "What's included in the free tier?",
          answer: 'The free tier gives you access to analyze one flow with basic recommendations and 7-day performance tracking. Perfect for testing Flowsense before upgrading.'
        }, {
          question: 'Can I cancel anytime?',
          answer: 'Yes, you can cancel your subscription at any time. There are no long-term contracts or cancellation fees.'
        }, {
          question: 'Do you offer refunds?',
          answer: "We offer a 30-day money-back guarantee. If you're not satisfied with Flowsense, just let us know and we'll refund your payment."
        }, {
          question: 'How does agency pricing work?',
          answer: 'Agencies pay $500/year for the first client, then $300/year for each additional client. All clients get full Pro features with white-label reporting.'
        }]} data-id="element-443" />
        </Container>
      </section>

      {/* CTA */}
      <section className="py-24" data-id="element-444">
        <Container data-id="element-445">
          <div className="bg-gray-900 rounded-3xl overflow-hidden shadow-2xl text-center py-16 px-6 lg:py-24 lg:px-12" data-id="element-446">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6" data-id="element-447">
              Ready to optimize your Klaviyo flows?
            </h2>
            <p className="text-xl text-gray-300 mb-10" data-id="element-448">
              Start your free trial today and see how Flowsense can improve your
              email marketing performance.
            </p>
            <a href="https://app.useflowsense.com/auth/signup" data-id="element-449">
              <Button size="lg" data-id="element-450">Sign Up</Button>
            </a>
          </div>
        </Container>
      </section>
    </div>;
}